import { render, staticRenderFns } from "./DashboardPprLayout.vue?vue&type=template&id=04a7d195"
import script from "./DashboardPprLayout.vue?vue&type=script&lang=js"
export * from "./DashboardPprLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardPprLayout.vue?vue&type=style&index=0&id=04a7d195&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports